<template>
  <div>
    <div class="row lookUpControl" v-if="labelPosition === 'left'">
      <div class="col-md-4">
        <label
          class="form-control-label"
          :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
        >{{control.label}}</label>
      </div>
      <div class="col-md-8">
        <multiselect
          v-model="users"
          :options="usersSelect"
          track-by="value"
          label="text"
          :searchable="true"
          selectLabel
          selectedLabel
          tagPlaceholder
          placeholder
          deselectLabel
          :allow-empty="true"
          :multiple="true"
          @select="save"
          @remove="save"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
    <div v-else>
      <label
        class="form-control-label"
        :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}"
      >{{control.label}}</label>
      <div>
        <multiselect
          v-model="users"
          :options="usersSelect"
          track-by="value"
          label="text"
          selectedLabel
          :searchable="true"
          selectLabel
          tagPlaceholder
          placeholder
          deselectLabel
          :allow-empty="true"
          :multiple="true"
          @select="save"
          @remove="save"
          :disabled="control.readonly"
          openDirection="bottom"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// services
import db from '@/services/db'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      gridId: null,
      rowKey: null,
      cellKey: null,
      options: null,
      users: [],
    }
  },
  watch: {
    ['control.value']() {
      this.setSelectedUsers()
    },
  },
  computed: {
    ...mapState(['userList', 'dataGrid_options']),
    usersSelect() {
      const userList = []

      for (let user of this.userList) {
        userList.push({ text: user.email || user.uid, value: user.uid })
      }

      return userList
    },
  },
  methods: {
    setSelectedUsers() {
      const dbUsers = this.control.value ? this.control.value.split(',') : []
      const users = []

      for (let user of dbUsers) {
        const idx = _.findIndex(this.usersSelect, { value: user })
        users.push(this.usersSelect[idx])
      }

      this.users = users
    },
    save() {
      this.$nextTick(() => {
        const users = []

        for (let user of this.users) {
          users.push(user.value)
        }

        const value = users.join(',') || null

        this.control.value = value

        const data = {
          options: this.options,
          rowKey: this.rowKey,
          cellKey: this.cellKey,
          value,
        }

        db.dataGrid.data.saveCellVal(data)
      })
    },
  },
  created() {
    this.$nextTick(() => {
      const formBuilderInst = this.$instByClass(this, 'form-builder-root')

      this.gridId = formBuilderInst.gridId
      this.rowKey = formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[this.gridId]

      this.setSelectedUsers()
    })
  },
}
</script>
